





























































import Vue from 'vue'
import Component from 'vue-class-component'
import { Debounce } from 'vue-debounce-decorator'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import ScrollView from '@/components/ScrollView.vue'
import Icon from '@/components/Icon.vue'
import { VPopover } from 'v-tooltip'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import { ResidentModule } from '@/store/modules/resident.module'
import { getModule } from 'vuex-module-decorators'

@Component({
  components: {
    InputV2,
    Icon,
    ScrollView,
    LoaderWrapper,
    VPopover
  },
  props: {
    placeholder: {
      type: String
    },
    searchFunction: {
      type: Function,
      required: true
    },
    searchParam: {
      type: String,
      required: true
    },
    searchResult: {
      type: Array,
      required: true
    }
  }
})
export default class AsyncSearchInput extends Vue {
  residentModuleInstance: ResidentModule = getModule(ResidentModule, this.$store)
  searchValue: string = ''
  isLoading: boolean = false
  isClosed: boolean = true
  selectedIndex: number = 0
  lastPageLoadedAt: number = 0

  getScrollEndEvent () {
    // if all loaded return null in order to prevent infinite loading
    return this.residentModuleInstance.isAllQuickSearchPagesLoaded ? null : `reachScrollEnd`
  }

  resetSearchData () {
    this.residentModuleInstance.RESET_RESIDENT_QUICK_SEARCH_CURRENT_LIMIT()
    this.residentModuleInstance.UPDATE_ALL_QUICK_SEARCH_PAGES_LOADED(false)
    const scrollbar: any = this.$refs.scrollbar
    if (scrollbar) scrollbar.$el.scrollTo(0, 0)
  }

  mounted () {
    this.$watch('searchValue', this.initSearch)
  }

  setClosed (value: boolean = true) {
    if (value) {
      this.residentModuleInstance.RESET_RESIDENT_QUICK_SEARCH_CURRENT_LIMIT()
      this.residentModuleInstance.UPDATE_RESIDENT_LIST_QUICK_SEARCH(
        this.residentModuleInstance.residentsQuickSearch.slice(0, this.residentModuleInstance.residentQuickSearchCurrentLimit)
      )
      this.residentModuleInstance.UPDATE_ALL_QUICK_SEARCH_PAGES_LOADED(false)
      this.lastPageLoadedAt = Date.now()
    }
    this.isClosed = value
  }

  async handleScrollEnd () {
    if (this.isClosed) { return }
    // Adding throttling because reachScrollEnd triggers multiple times
    if (this.lastPageLoadedAt + 200 > Date.now()) { return }
    this.lastPageLoadedAt = Date.now()
    await this.loadNextPage()
  }

  async loadNextPage () {
    if (this.residentModuleInstance.isAllQuickSearchPagesLoaded) return
    const limit = this.residentModuleInstance.residentQuickSearchCurrentLimit + this.residentModuleInstance.residentQuickSearchPageSize
    this.residentModuleInstance.UPDATE_RESIDENT_QUICK_SEARCH_LIMIT(limit)
    await this.loadData()
  }

  @Debounce(400)
  async initSearch () {
    if (!this.searchValue) {
      return
    }
    this.setClosed(false)
    await this.loadData()
  }

  async loadData () {
    this.isLoading = true
    await this.$props.searchFunction({
      [this.$props.searchParam]: this.searchValue,
      limit: this.residentModuleInstance.residentQuickSearchCurrentLimit
    })
    this.isLoading = false
  }

  selectSelectedIndexItem () {
    // @ts-ignore
    const ref = this.$refs.scrollbar.$el
    ref.querySelector(`.searchResult-${this.selectedIndex} > *`).click()
    this.setClosed()
  }

  changeSelectedIndex (direction: string | null, index: number | null = null) {
    if (this.isLoading) {
      return
    }

    if (direction) {
      const alignScroll = () => {
        const scrollbar: any = this.$refs.scrollbar
        const rect = scrollbar.$el.getBoundingClientRect()
        const itemHeight = 46.2
        const height = rect.height
        const currentPositionTop = this.selectedIndex * itemHeight
        if (currentPositionTop - scrollbar.$el.scrollTop > height - itemHeight && direction === 'down') {
          scrollbar.$el.scrollTop = currentPositionTop - height + itemHeight
        } else if (currentPositionTop < scrollbar.$el.scrollTop && direction === 'up') {
          scrollbar.$el.scrollTop = currentPositionTop - itemHeight
        }
      }

      if (direction === 'up' && this.selectedIndex > 0) {
        this.selectedIndex--
        alignScroll()
      } else if (this.selectedIndex < this.$props.searchResult.length - 1) {
        this.selectedIndex++
        alignScroll()
      }
      return
    }
    if (index || index === 0) {
      this.selectedIndex = index
    }
  }
}
